import {PaletteStatus} from "../skin/colors/@types";

export enum SystemStatus {
    NOT_STARTED     = 1,
    IN_PROGRESS     = 2,
    IN_REVIEW       = 3,
    ON_HOLD         = 4,
    COMPLETED       = 5,
    CANCELLED       = 6
}

export const SystemStatusOptions : Options = [
    {
        label: 'Not Started',
        value: SystemStatus.NOT_STARTED,
        color: PaletteStatus.BLUE
    },
    {
        label: 'In Progress',
        value: SystemStatus.IN_PROGRESS,
        color: PaletteStatus.GREEN
    },
    {
        label: 'Review',
        value: SystemStatus.IN_REVIEW,
        color: PaletteStatus.ORANGE
    },
    {
        label: 'On Hold',
        value: SystemStatus.ON_HOLD,
        color: PaletteStatus.VIOLET
    },
    {
        label: 'Closed / Archived',
        value: SystemStatus.COMPLETED,
        color: PaletteStatus.GRAY
    },
    {
        label: 'Cancelled',
        value: SystemStatus.CANCELLED,
        color: PaletteStatus.GRAY
    },
]

export const SystemStatusFolderOptions : Options = [
    {
        label: 'In Progress',
        value: SystemStatus.IN_PROGRESS,
        color: PaletteStatus.BLUE
    },
    {
        label: 'Archived',
        value: SystemStatus.COMPLETED,
        color: PaletteStatus.GRAY
    }
]

// old version: TableViewSystemStatus
export enum SystemStatusGroup {
    ALL     = "all",
    OPEN    = "open",
    CLOSED  = "closed"
}

export const ALL_STATUSES  = [1,2,3,4,5,6]
export const OPEN_STATUSES      = [1,2,3,4]
export const CLOSED_STATUSES    = [5,6]


export const SystemStatuses: {[key: string]: SystemStatus[]} = {
    [SystemStatusGroup.ALL]     : [
        SystemStatus.NOT_STARTED,
        SystemStatus.IN_PROGRESS,
        SystemStatus.IN_REVIEW,
        SystemStatus.ON_HOLD,
        SystemStatus.COMPLETED,
        SystemStatus.CANCELLED
    ],
    [SystemStatusGroup.OPEN]    : [
        SystemStatus.NOT_STARTED,
        SystemStatus.IN_PROGRESS,
        SystemStatus.IN_REVIEW,
        SystemStatus.ON_HOLD,
    ],
    [SystemStatusGroup.CLOSED]  : [
        SystemStatus.COMPLETED,
        SystemStatus.CANCELLED
    ]
}
